
import Vue from "vue"
import {mapActions} from "vuex"
import Auth from "@/views/Auth/components/Auth.vue"
import BackToLogin from "@/views/Auth/components/BackToLogin.vue"
import RestorePasswordForm from "@/components/forms/RestorePasswordForm.vue"
import {restorePasswordErrorText} from "@/views/Auth/utils/authErrors"

export default Vue.extend({
  name: "Restore",

  data() {
    return {
      successfulReset: false,
      email: "",
      windowHeight: window.innerHeight,
      loading: false,
      errorText: "",
    }
  },

  components: {
    RestorePasswordForm,
    Auth,
    BackToLogin,
  },

  methods: {
    ...mapActions("auth", ["restore"]),

    resetPassword(email: any) {
      if (this.loading) return
      this.loading = true
      this.errorText = ""
      this.restore(email)
        .then(() => {
          this.loading = false
          this.successfulReset = true
          this.email = email
        })
        .catch((error: any) => {
          this.loading = false
          this.errorText = restorePasswordErrorText(error)
        })
    },
  },
})
